import { uniq, difference } from 'lodash';

// REDUCER
import {
	TIMELINE_RECV_INIT_DATA,
	TIMELINE_RECV_NEXT_DATA,
	TIMELINE_RECV_PREV_DATA,
	TIMELINE_REQ_DATA,
	TIMELINE_RECV_ERROR,
	TIMELINE_CLEAR_DATA,
	TIMELINE_FILTER,
} from '../constants/actions';

const defaultState = {
	update: 0,
	filters: false,
	items: getPageSplitter(),
	next: null,
	prev: null,
	isFetching: false,
	skip: 0,
	startPage: 0,
};

function getPageSplitter() {
	return [{
		type: 'page-indicator',
		uid: Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1),
	}];
}

function timelineReceived(state, payload, append, init = false) {
	// console.log(payload);
	// let perfNow = performance.now() / 1000;
	// console.log((performance.now() / 1000) - perfNow + ' - reducer: ');

	if (payload && payload.hasOwnProperty('items')) {
		let currentItems = state.items;
		let payloadItems = payload.items;
		let nextItems;
		let pagination = {
			prev: state.prev,
			next: state.next,
		};
		let startPage = 0;

		// console.log((performance.now() / 1000) - perfNow + ' - reducer: before ne');
		payloadItems = append ? payloadItems.concat(getPageSplitter()) : getPageSplitter().concat(payloadItems);

		if (init) {
			pagination.next = payload.next;
			pagination.prev = payload.prev;
			nextItems = getPageSplitter().concat(payloadItems);
		} else {
			// console.log(`${append ? 'next' : 'prev'}: ${append ? payload.next : payload.prev}`);
			nextItems = append ? currentItems.concat(payloadItems) : payloadItems.concat(currentItems);
			pagination[append ? 'next' : 'prev'] = (append ? payload.next : payload.prev);
		}
		// console.log((performance.now() / 1000) - perfNow + ' - reducer: nextItems created');

		if (pagination.prev) {
			let offsetStr = pagination.prev;
			startPage = parseInt(offsetStr.substr(offsetStr.indexOf('offset=') + 7, offsetStr.length), 10) / 20;
		}

		nextItems = uniq(nextItems, function(n) {
			return n.uid;
		});

		nextItems = difference(nextItems, [false, undefined, null]);
		// console.log((performance.now() / 1000) - perfNow + ' - reducer: validation');

		let skipCount = 0;
		for (var i = 0; i < nextItems.length; i++) {
			if (typeof nextItems[i] === 'object' && nextItems[i].hasOwnProperty('hero') && nextItems[i].hero) {
				break;
			}

			skipCount++;
		}
		// console.log((performance.now() / 1000) - perfNow + ' - reducer: skip counted');

		let returnValue = {
			...state,
			...pagination,
			update: state.update + 1,
			isFetching: false,
			items: nextItems,
			skip: skipCount,
			startPage,
		}
		// console.log((performance.now() / 1000) - perfNow + ' - reducer: return value created');

		return returnValue;
	}

	return state;
}

function initData(state, payload, append) {
	let stateHolder = state;

	if (payload.hasOwnProperty('filter') && Object.keys(payload.filter).length) {
		stateHolder = {
			...state,
			filters: payload.filter,
		};
	}

	return timelineReceived(stateHolder, payload.data, append, true);
}

function timelineSetFilter(state, payload) {
	//console.log(payload);
	return {
		...state,
		filters: payload,
	};
}

export default function timelineReducer(state = defaultState, action) {
	//console.log('%c------------', action.type === TIMELINE_RECV_INIT_DATA ? 'color: red;' : '');
	//console.log(action.type);
	//console.log('%c------------', action.type === TIMELINE_RECV_INIT_DATA ? 'color: red;' : '');

	switch (action.type) {
		case TIMELINE_RECV_INIT_DATA:
			return initData(state, action.payload, true);
		case TIMELINE_RECV_NEXT_DATA:
			return timelineReceived(state, action.payload, true);
		case TIMELINE_RECV_PREV_DATA:
			return timelineReceived(state, action.payload, false);
		case TIMELINE_REQ_DATA:
			return {...state, isFetching: true};
		case TIMELINE_RECV_ERROR:
			return {...state, isFetching: false, update: state.update + 1};
		case TIMELINE_CLEAR_DATA:
			return {...state, items: [], next: null, prev: null, update: 0};
		case TIMELINE_FILTER:
			return timelineSetFilter(state, action.payload);
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/timelines.js
 **/